import { render, staticRenderFns } from "./MyOrders.vue?vue&type=template&id=ec44b892&scoped=true"
import script from "./MyOrders.vue?vue&type=script&lang=js"
export * from "./MyOrders.vue?vue&type=script&lang=js"
import style0 from "./MyOrders.vue?vue&type=style&index=0&id=ec44b892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec44b892",
  null
  
)

export default component.exports